<template>
    <a class="btn" :href="href" :target="target" :class="className" @click="callback($event)">{{text}}</a>
</template>

<script>
export default {
        name: 'btn',
        props: {
            text: {
                type: String,
                required: true,
            },
            className: {
                type: String,
                required: false,
            },
            href: {
                type: String,
                required: false,
            },
            target: {
                type: String,
                required: false,
            }
        },
        emits: ['click'],
        methods: {
            callback: function(e) {
                this.$emit('click', e);
            }
        }
    }
</script>